import './ChipStatus.css';

/**
 * Tom do chip de estado.
 *
 * O sistema de design fixa cinco tons. Cada um combina ponto de cor **e**
 * rótulo — nunca cor sozinha, porque a varredura vertical da tabela precisa
 * funcionar em monitor mal calibrado e para quem não distingue as cores.
 */
export type TomStatus = 'andamento' | 'concluida' | 'divergencia' | 'falha' | 'desativado';

type Props = {
  readonly tom: TomStatus;
  readonly rotulo: string;
  /** `tabela` reduz de 26px para 24px, a altura usada dentro das linhas. */
  readonly tamanho?: 'padrao' | 'tabela';
};

export function ChipStatus({ tom, rotulo, tamanho = 'padrao' }: Props) {
  return (
    <span className={`chip chip--${tom} chip--${tamanho}`}>
      <span className="chip__ponto" />
      {rotulo}
    </span>
  );
}
